import { notifications } from '@mantine/notifications';
import { toggleGroupProperty } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useToggleGroupProperty = ({ type, property }) => {
    const entityUpdater = useEntityQueryUpdate();

    const toggleGroupPropertyMutation = useMutation({
        mutationKey: `toggle_${type}_${property}`,
        mutationFn: ({ id, ...rest }) =>
            toggleGroupProperty({
                id: id,
                type: type,
                model: {
                    ...rest,
                    property,
                },
            }),
        onSuccess: (data) => {
            let logType = null;
            switch (type) {
                case 'messages':
                    /*entityUpdater(
                        [['campaign_messages'], ['campaign_message', data.id]],
                        data
                    );*/
                    logType = 'message';
                    break;

                case 'links':
                    /*entityUpdater(
                        [['campaign_links'], ['campaign_link', data.id]],
                        data
                    );*/
                    logType = 'link';
                    break;

                case 'media':
                    /*entityUpdater(
                        [['campaign_media'], ['campaign_media', data.id]],
                        data
                    );*/
                    logType = 'media';
                    break;
            }

            notifications.show({
                title: 'Success',
                message: `Successfully updated ${logType}`,
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return toggleGroupPropertyMutation;
};
export default useToggleGroupProperty;
